import { render, staticRenderFns } from "./custom-picture-type-1.vue?vue&type=template&id=3e69a1b3&scoped=true&"
import script from "./custom-picture-type-1.vue?vue&type=script&lang=js&"
export * from "./custom-picture-type-1.vue?vue&type=script&lang=js&"
import style0 from "./custom-picture-type-1.vue?vue&type=style&index=0&id=3e69a1b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e69a1b3",
  null
  
)

export default component.exports